export default "__VITE_ASSET__BbSFUI5W__"